<template>
  <div v-if="cafeInfo">
    <div class="container cafe-img-container">
      <img class="center-img fit-img" :src="cafeInfo.shopImgUrl" />
      <router-link to="/home" replace>
        <img class="back-icon" src="assets/icon/arrowleft-circle.svg" />
      </router-link>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "cafeItemHeader",
  components: {},
  props: {
    cafeInfo: Object,
  },
  data() {
    return {
      isProcessing: false,
    };
  },
});
</script>
<style scoped>
.container {
  position: relative;
  overflow: hidden;
  /* Extend into safe area on iOS */
  margin-top: calc(-1 * env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
}
div .fit-img {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.container img {
  display: block;
  height: 200px;
}
.center-img {
  margin-left: auto;
  margin-right: auto;
}
.container .back-icon {
  position: absolute;
  top: calc(env(safe-area-inset-top) + 20px);
  left: 20px;
  z-index: 102;
}
.back-icon {
  height: 36px;
  width: 36px;
}
/* iPhone SE */
@media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 1) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}
/* iPhone X, XS, 11 Pro, 12 Mini */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}

/* iPhone XR, 11 */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}

/* iPhone XS Max, 11 Pro Max, 12 Pro Max */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}

/* iPhone 13, 13 Pro */
@media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}

/* iPhone 13 Mini */
@media only screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}

/* iPhone 13 Pro Max */
@media only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}
/* iPhone 14 Pro Max, iPhone 15 Pro Max, iPhone 16 Pro Max */
@media only screen and (device-width: 430px) and (device-height: 932px) and (-webkit-device-pixel-ratio: 3) {
  .container .back-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    left: 20px;
    z-index: 102;
  }
  .container .heart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 20px;
  }
  .container .cart-icon {
    position: absolute;
    top: calc(env(safe-area-inset-top) + 20px);
    right: 80px;
  }
}
</style>
